// =============================================================================
// SHANIZ GAMING ADMIN - PERMISSION-AWARE BUTTON
// =============================================================================

import React from 'react';
import { Button, ButtonProps, Tooltip, IconButton, IconButtonProps } from '@mui/material';
import { usePermission, PermissionKey } from '../hooks/usePermission';

interface PermissionButtonProps extends ButtonProps {
  permission: PermissionKey;
}

export const PermissionButton: React.FC<PermissionButtonProps> = ({ permission, disabled, children, ...rest }) => {
  const { allowed, reason } = usePermission(permission);
  const isDisabled = disabled || !allowed;
  const btn = (
    <span>
      <Button {...rest} disabled={isDisabled}>
        {children}
      </Button>
    </span>
  );
  if (!allowed && reason) {
    return <Tooltip title={reason}>{btn}</Tooltip>;
  }
  return btn;
};

interface PermissionIconButtonProps extends IconButtonProps {
  permission: PermissionKey;
}

export const PermissionIconButton: React.FC<PermissionIconButtonProps> = ({ permission, disabled, children, ...rest }) => {
  const { allowed, reason } = usePermission(permission);
  const isDisabled = disabled || !allowed;
  const btn = (
    <span>
      <IconButton {...rest} disabled={isDisabled}>
        {children}
      </IconButton>
    </span>
  );
  if (!allowed && reason) {
    return <Tooltip title={reason}>{btn}</Tooltip>;
  }
  return btn;
};
